import { render, staticRenderFns } from "./CoffeeSettings.vue?vue&type=template&id=3c9114f7&scoped=true"
import script from "./CoffeeSettings.vue?vue&type=script&lang=js"
export * from "./CoffeeSettings.vue?vue&type=script&lang=js"
import style0 from "./CoffeeSettings.vue?vue&type=style&index=0&id=3c9114f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9114f7",
  null
  
)

export default component.exports